<template>

  <div class="sidebar" v-on-clickaway="hideMobile">
    <slot>Sidebar</slot>
  </div>

<!--
  <div v-on-clickaway="hideMobile"
    :class="{
      sidebar: true,
      'sidebar-open': isSiderbarOpened === true,
      'sidebar-close': isSiderbarOpened === false,
    }"
  >
    <slot>Sidebar</slot>
  </div>
  -->
</template>
<script>
import { mapState } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
import { hideMobile } from '@src/mixins/hideMobile'

export default {
  name: 'Sidebar',
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ clickaway, hideMobile ],
  computed: {
    ...mapState('layout', {
      isSiderbarOpened: (state) => state.isSidebarOpened,
    }),
    mq() {
      return this.$mq
    },
  },
  watch: {
    mq: function(val) {
      if (val === 'lg') {
      }
    },
  },
  mounted: function() {
    this.isFixed()
  },
  methods: {
    isFixed() {
      this.fixed
        ? document.body.classList.add('sidebar-fixed')
        : document.body.classList.remove('sidebar-fixed')
      return this.fixed
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar.sidebar-open {
  margin-left: 0 !important;
}

.sidebar.sidebar-close {
  margin-left: -200px !important;
}
</style>
